import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import 'swiper/css/navigation';
import { fadeInBlock }  from '@ts/utils';

let scrolling = false;

export const init = () => {    
    // Setup
    setScrollEvents();
    setSwipers();
    setImagePopIns();
    setAnimatedMetrics();
    fadeInBlock();
    setHearts();
    setFAQToggle();
};

// Heart Bar Parallax
const setHearts = () => {
    const scrolled = window.scrollY;
    const heartBar = document.querySelector('.heart-bar');
    if (heartBar) heartBar.style.backgroundPositionY = `${scrolled * 0.1}px`; 
}

const scrollEvents = () => {    
    if (!scrolling) {
        scrolling = true;
        requestAnimationFrame(() => {
            scrolling = false;
            fadeInBlock();
            setHearts();
        });
    }
}

const setScrollEvents = () => {
    window.addEventListener('scroll', scrollEvents, { passive: true });
};

const animateCountUp = (el, duration = 1500) => {
    const target = Number(el.dataset.metricTarget);
    const startTime = performance.now();

    const update = (currentTime) => {
        const elapsed = currentTime - startTime;
        const progress = Math.min(elapsed / duration, 1);
        const current = Math.floor(progress * target);

        el.textContent = current.toString();

        if (progress < 1) requestAnimationFrame(update);
        else el.textContent = target.toLocaleString(); 
    }
    requestAnimationFrame(update);
}

const metricObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            animateCountUp(entry.target);
            metricObserver.unobserve(entry.target);
        }
    });
});

const setAnimatedMetrics = () => {
    document.querySelectorAll('.metric-value').forEach(el => metricObserver.observe(el));
};

const setSwipers = () => {
    if (document.querySelector('.easy-steps-gallery')) {
        const easyStepGallery = new Swiper(".easy-steps-gallery", {
            speed: 600,
            loop: true,
        });

        document.querySelectorAll(".step-indicators button").forEach(btn => {
            btn.addEventListener("click", () => {
                document.querySelectorAll(".step-indicators button")
                    .forEach(b => b.classList.remove("active"));

                easyStepGallery.slideTo(Number(btn.dataset.step));
                btn.classList.add("active");
            });
        });
    }

    if (document.querySelector('.partners')) {
        new Swiper(".partners", {
            autoplay: {
                delay: 3000,
                disableOnInteraction: false,
            },
            loop: true,
            slidesPerView: 2,
            slidesPerGroup: 1,
            spaceBetween: 10,
            speed: 800,
            breakpoints: {
                320: { slidesPerView: 2, spaceBetween: 10 },
                576: { slidesPerView: 3, spaceBetween: 25 },
                768: { slidesPerView: 4, spaceBetween: 30 },
                992: { slidesPerView: 5, spaceBetween: 35 },
                1200: { slidesPerView: 8, spaceBetween: 30 },
            }
        });
    }
};

const setImagePopIns = () => {
    const popObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('visible');
            }
        });
    }, { threshold: 0.5 });

    document.querySelectorAll('.image-pop-in').forEach(el => popObserver.observe(el));
};

const setFAQToggle = () => {
    document.querySelectorAll('.questions .question').forEach(question => {
        question.addEventListener('click', (e) => {
            e.preventDefault();
            const answer = question.querySelector('.question-answer');

            if (!answer) return;

            const isOpen = answer.classList.toggle('show');
            const icon = question.querySelector('svg');

            if (icon) {
                icon.classList.toggle('fa-circle-plus', !isOpen);
                icon.classList.toggle('fa-circle-minus', isOpen);
                icon.setAttribute('data-icon', isOpen ? 'circle-minus' : 'circle-plus');
            }
        });
    });
};